import type { SVGProps } from 'react';

export const IconAttachmentClose = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    {...props}
  >
    <path
      d="M16.1003 4.95821L11.3137 9.74478L6.52714 4.95821L4.78657 6.69878L9.57314 11.4854L4.78657 16.2719L6.52714 18.0125L11.3137 13.2259L16.1003 18.0125L17.8408 16.2719L13.0543 11.4854L17.8408 6.69878L16.1003 4.95821Z"
      fill="currentColor"
    />
  </svg>
);

export const IconAttachmentPrevious = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="18"
    viewBox="0 0 12 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    {...props}
  >
    <path
      d="M9.47659 17.1668C9.47659 17.1668 9.3657 17.082 9.3261 17.0473C6.56188 14.3507 0.882949 8.79183 0.882949 8.75716C0.958193 8.69937 5.47678 4.32314 7.66281 2.1928C8.25684 1.61496 8.85087 1.03711 9.49639 0.40918C10.0706 0.983175 10.633 1.55332 11.1953 2.12346V2.17739C11.1557 2.20821 6.67672 6.55748 4.47881 8.69937C4.44317 8.73404 4.41149 8.77642 4.37585 8.81879C4.42337 8.86887 4.45901 8.9074 4.49465 8.94592C6.68068 11.0724 8.86671 13.2027 11.0527 15.3331C11.0963 15.3754 11.1953 15.4795 11.1953 15.4949C10.6211 16.0534 10.0508 16.6082 9.47659 17.1668Z"
      fill="currentColor"
    />
  </svg>
);

export const IconAttachmentNext = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="18"
    viewBox="0 0 12 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    {...props}
  >
    <path
      d="M2.52341 0.273659C2.52341 0.273659 2.6343 0.35841 2.6739 0.393082C5.43812 3.08971 11.1171 8.6486 11.1171 8.68327C11.0418 8.74106 6.52322 13.1173 4.33719 15.2476C3.74316 15.8255 3.14913 16.4033 2.50361 17.0312C1.92938 16.4573 1.36704 15.8871 0.804688 15.317V15.263C0.84429 15.2322 5.32328 10.8829 7.52119 8.74106C7.55683 8.70639 7.58851 8.66401 7.62415 8.62164C7.57663 8.57156 7.54099 8.53303 7.50535 8.49451C5.31932 6.36803 3.13329 4.2377 0.947255 2.10736C0.903693 2.06499 0.804688 1.96098 0.804688 1.94557C1.37892 1.38698 1.94919 0.832245 2.52341 0.273659Z"
      fill="currentColor"
    />
  </svg>
);

export const IconAttachmentDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 8.21h-5.14V2H7.14v6.21H2L12 18.95 22 8.21zM2 20.21V22h20v-1.79H2z"
      fill="currentColor"
    />
  </svg>
);

export const IconAttachmentPrint = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    {...props}
  >
    <path
      d="M19 8H5C3.345 8 2 9.345 2 11V17H6V21H18V17H22V11C22 9.345 20.655 8 19 8ZM16 19H8V14H16V19ZM19 12C18.445 12 18 11.555 18 11C18 10.445 18.445 10 19 10C19.555 10 20 10.445 20 11C20 11.555 19.555 12 19 12ZM18 3H6V7H18V3Z"
      fill="currentColor"
    />
  </svg>
);
